'use client'
import Link from 'next/link'
import { useBreadcrumbsStore } from './breadcrumbs.store'
import { cn } from '@/lib/utils'
import Text from '@/components/custom-ui/text'
import { Fragment } from 'react'

type BreadcrumbNavigationProps = {
  className?: string
}

export default function BreadcrumbNavigation({
  className,
}: BreadcrumbNavigationProps) {
  let breadcrumbs = useBreadcrumbsStore()((state) => state.breadcrumbs)

  return (
    <div
      className={cn(
        'container flex min-h-10 max-w-nav gap-2 px-5 py-2 md:min-h-14 md:px-0 md:py-4',
        className,
      )}
    >
      {breadcrumbs.length > 0 ? (
        breadcrumbs.map((breadcrumb, index) => {
          const isLast = index + 1 === breadcrumbs.length
          return (
            <Fragment key={breadcrumb.id}>
              <Link
                href={breadcrumb.path}
                className={cn(
                  'font-light hover:text-primary',
                  isLast && 'font-medium',
                )}
              >
                <Text styleAs="p">{breadcrumb.title}</Text>
              </Link>
              {!isLast && <span>/</span>}
            </Fragment>
          )
        })
      ) : (
        <div aria-hidden="true" className="invisible min-h-[inherit]">
          /
        </div>
      )}
    </div>
  )
}
